import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  showSuccess(summary: string, detail?: string) {
    this.messageService.add({
      key: 'global',
      severity: 'success',
      summary: summary,
      detail: detail,
    });
  }

  showError(summary: string, detail?: string) {
    this.messageService.add({
      key: 'global',
      severity: 'error',
      summary: summary,
      detail: detail,
    });
  }

  showInfo(summary: string, detail?: string) {
    this.messageService.add({
      key: 'global',
      severity: 'info',
      summary: summary,
      detail: detail,
    });
  }

  showWarning(summary: string, detail: string) {
    this.messageService.add({
      key: 'global',
      severity: 'warn',
      summary: summary,
      detail: detail,
    });
  }
}
